// InfluencerCodes bei denen der Versand aktiviert wird
var shippingCodesArr 	= (shippingCodesArr === null || shippingCodesArr == "") ? "" : shippingCodesArr;
var shippingCodes 		= shippingCodesArr.split("|");
shippingCodes 			= shippingCodes.filter(function(e){return e}); 
var freeShipping 		= parseFloat(parseInt(shippingFreePrice) / 100).toFixed(2);
//console.log(shippingCodes,freeShipping);
// "DE","BE","DK","DE","EE","FI","FR","GR","IS","IT","LV","LI","LT","LU","MT","NL","NO","AT","PL","PT","SE","CH","SK","SI","ES","CZ","HU"
let countries 		= {
  BE: ['Belgien',150,freeShipping],
  DK: ['Dänemark',150,freeShipping],
  DE: ['Deutschland',55,freeShipping],
  EE: ['Estland',150,freeShipping],
  FI: ['Finnland',150,freeShipping],
  FR: ['Frankreich',150,freeShipping],
  GR: ['Griechenland',150,freeShipping],
  IS: ['Island',150,freeShipping],
  IT: ['Italien',150,freeShipping],
  LV: ['Lettland',150,freeShipping],
  LI: ['Liechtenstein',150,freeShipping],
  LT: ['Litauen',150,freeShipping],
  LU: ['Luxemburg',150,freeShipping],
  MT: ['Malta',150,freeShipping],
  NL: ['Niederlande',150,freeShipping],
  NO: ['Norwegen',150,freeShipping],
  AT: ['Österreich',55,freeShipping],
  PL: ['Polen',150,freeShipping],
  PT: ['Portugal',150,freeShipping],
  SE: ['Schweden',150,freeShipping],
  CH: ['Schweiz',150,freeShipping],
  SK: ['Slowakei',150,freeShipping],
  SI: ['Slowenien',150,freeShipping],
  ES: ['Spanien',150,freeShipping],
  CZ: ['Tschechien',150,freeShipping],
  HU: ['Ungarn',150,freeShipping],
  CY: ['Zypern',55,freeShipping]
}
